import * as i1 from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import * as i0 from '@angular/core';
import { Injector, Injectable, Optional } from '@angular/core';
import * as i2 from '@angular/router';
import { asArray } from '@ng-doc/core/helpers/as-array';
import { NgDocOverlayRef } from '@ng-doc/ui-kit/classes';
import { NgDocOverlayUtils } from '@ng-doc/ui-kit/utils';
import { PolymorpheusComponent } from '@tinkoff/ng-polymorpheus';
import { take } from 'rxjs/operators';
let NgDocOverlayService = /*#__PURE__*/(() => {
  class NgDocOverlayService {
    constructor(overlay, ngZone, injector, router) {
      this.overlay = overlay;
      this.ngZone = ngZone;
      this.injector = injector;
      this.router = router;
    }
    open(content, config, providers = []) {
      const overlayRef = this.createOverlay(config);
      return this.attachTooltipContainer(content, overlayRef, config, providers);
    }
    attachTooltipContainer(content, overlay, config, providers) {
      const containerPortal = new ComponentPortal(config.overlayContainer, config.viewContainerRef, config.viewContainerRef?.injector);
      const containerRef = overlay.attach(containerPortal);
      const overlayRef = new NgDocOverlayRef(overlay, config, containerRef.instance, this.ngZone, this.router);
      if (content instanceof PolymorpheusComponent) {
        content = new PolymorpheusComponent(content.component, this.createInjector(overlayRef, providers, config.viewContainerRef?.injector));
      }
      containerRef.setInput('config', config);
      containerRef.setInput('content', content);
      containerRef.instance.markForCheck();
      return overlayRef;
    }
    createOverlay(config) {
      const overlayRef = this.overlay.create(config);
      overlayRef.detachments().pipe(take(1)).subscribe(() => {
        overlayRef.hasAttached() && overlayRef.detach();
      });
      return overlayRef;
    }
    connectedPositionStrategy(origin, positions) {
      return this.overlay.position().flexibleConnectedTo(origin).withPositions(NgDocOverlayUtils.toConnectedPositions(asArray(positions))).withPush(true);
    }
    globalPositionStrategy() {
      return this.overlay.position().global();
    }
    scrollStrategy() {
      return this.overlay.scrollStrategies;
    }
    createInjector(overlayRef, providers, injector) {
      return Injector.create({
        providers: [...providers, {
          provide: NgDocOverlayRef,
          useValue: overlayRef
        }],
        parent: injector || this.injector
      });
    }
    static {
      this.ɵfac = function NgDocOverlayService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocOverlayService)(i0.ɵɵinject(i1.Overlay), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i2.Router, 8));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgDocOverlayService,
        factory: NgDocOverlayService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NgDocOverlayService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocOverlayService };
